(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('OpenId', OpenId);

    OpenId.$inject =['$resource', '$http', '$httpParamSerializerJQLike', 'urls', 'headerNames', 'mediaTypes', 'openIdGrantTypes', 'openIdScopes', 'httpMethods', 'statusCodes'];
    function OpenId($resource, $http, $httpParamSerializerJQLike, urls, headerNames, mediaTypes, openIdGrantTypes, openIdScopes, httpMethods, statusCodes) {
        var defaultTransformResponse = $http.defaults.transformResponse,
            defaultScope = Object.values(openIdScopes).join(' '),
            extend = angular.extend;

        return $resource('', null, {
            getToken: tokenRequest(),
            refreshToken: tokenRequest(true),

            getNgnToken: {
                url: urls.openIdNgnToken,
                method: httpMethods.post
            },
            getGcrToken: {
                url: urls.openIdGcrToken,
                method: httpMethods.post
            },
            getGeniusToken: {
                url: urls.openIdGeniusToken,
                method: httpMethods.post
            },
            impersonate: {
                url: urls.openIdImpersonate,
                method: httpMethods.post
            }
        });

        function tokenRequest(refresh) {
            var headers = {};
            headers[headerNames.contentType] = mediaTypes.applicationFormUrlEncoded;

            return {
                url: urls.openIdToken,
                method: httpMethods.post,
                headers: headers,
                transformRequest: transformRequest,
                allowAnonymous: true,
            };

            function transformRequest(data) {
                var grantType = refresh ? openIdGrantTypes.refreshToken : openIdGrantTypes.password,
                    data = extend({ scope: defaultScope, grant_type: grantType }, data);

                return $httpParamSerializerJQLike(data);
            }
        }
    }
})();